module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iNyIgdmlld0JveD0iMCAwIDE0IDciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xMi42MDAxIDAuNTk5OTc2TDYuOTUzNjUgNi4yNDY0MkM2Ljc1ODM5IDYuNDQxNjggNi40NDE4MSA2LjQ0MTY4IDYuMjQ2NTQgNi4yNDY0MkwwLjYwMDA5OCAwLjU5OTk3NSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ico-svg/Flecha.svg
// module id = lOMk
// module chunks = 62